module.exports = __webpack_public_path__ + "media/conversa/iconWarning-15c20db9.png";